import React from 'react'
import { formDataProductIsField, formDataProductRequiredField } from '../../../../../helpers/form/FormData'
import { checkValid, setValueForm, updateValidate } from '../../../../../helpers/form/FormHelper'
import ErrorMessage from '../../../../UI/messages/ErrorMessage'
import MyButton from '../../../../UI/form/MyButton'
import { useDispatch } from 'react-redux'
import { useState } from 'react'
import { useEffect } from 'react'
import DateFieldValidate from '../../../../validate/form/date/DateFieldValidate'
import DateFieldMain from '../../../../form/fields/DateFieldMain'
import { responseError } from '../../../../../helpers/response/ResponseHelper'
import { editWriteOffActItem } from '../../../../../store/writeOffSlice'
import { editWriteOffctItemDateReceiptAPI } from '../../../../../api/writeOff/writeOffActItemAPI'

const ChangeDateReceiptForm = ({ writeOffActItemBd, setOpen }) => {

    const dispatch = useDispatch()

    const [data, setData] = useState(
        writeOffActItemBd ? 
            {
                dateReceipt: writeOffActItemBd.dateReceipt,
            } 
        : {}
    ) // Дані з форми

    // console.log('data', data)
        
    const [valid, setValid] = useState({}) // Валідація кожного поля
    const [loading, setLoading] = useState(false)

    const [isValidForm, setIsValidForm] = useState(false) // Загальна валідація форми
    const [result, setResult] = useState('')
    const [error, setError] = useState('')

    useEffect(() => {
        checkValid(valid, setIsValidForm)
    }, [valid])

    const save = (e) => {
        e.preventDefault()
        const dataForBd = getDataForBd()

        setError('')
        setLoading(true)

        editWriteOffctItemDateReceiptAPI(dataForBd).then(data => {
            if (data) {
                dispatch(editWriteOffActItem(data))
            }

            setOpen(false)
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            setLoading(false)
        })
    }

    const getDataForBd = () => {
        const dataForBd = {
            id: writeOffActItemBd.id,
            dateReceipt: data.dateReceipt,
        }

        return dataForBd
    }

  return (
    <div className='myFormSimple'>
        {
			formDataProductIsField('dateReceipt', 'writeOffActItem') ?
				<DateFieldMain
					required={formDataProductRequiredField('dateReceipt', 'writeOffActItem')}
					setValidate={e => updateValidate(setValid, 'dateReceipt', e)}
					setValueForm={e => setValueForm(setData, 'dateReceipt', e)}
					forciblyValue={data && data.dateReceipt ? data.dateReceipt : ''}
                    label='Дата надходження'
                    // placeholder='Введіть дату'
				/>
			: ''
        }

        <ErrorMessage
            error={error}
        />

        <MyButton
            size='md'
            onClick={save}
            disabled={!isValidForm || loading ? true : false}
        >
            Зберегти
        </MyButton>
    </div>
  )
}

export default ChangeDateReceiptForm